<template lang="pug">
  .row.col-md-12
    .btn-group
      button.btn.btn-md.btn-default(v-for="(fb, index) in filterButtons" :class="{ active: activeFilterIndex === index }" @click="activeFilterIndex = index; activeFilterType = fb.type") {{fb.text}}
    .btn-group.p10
      LocationPicker(v-model="location")
    .btn-group
      ProductSelect(v-model="productId")
    .btn-group.p10
      PackageSelect(v-model="packageId")
    .btn-group
      button.btn.btn-default(v-for="(dtb, index) in dataTypeButtons" :class="{ active: activeDataTypeIndex === index }" @click="activeDataTypeIndex = index")
        i(:class="dtb.icon")
    div(v-if="activeDataTypeIndex === 0")
      .list-group-item(v-for="u in filteredUploaded ")
        span {{u.packageName}}
        span(v-if="u.productName && activeFilterIndex !== 1")  -
          a(@click="goToProduct(u.productId)") {{u.productName}}
        span.badge {{u.count | number}}
      .list-group-item(v-if="uploaded.length === 0")
        span Total items
        span.badge 0
    div(v-if="activeDataTypeIndex === 1")
      PieChart(:chartData="pieData" :options="pieOptions" :height="500")
    div(v-if="activeDataTypeIndex === 2")
      BarChart(:chartData="chartData" :options="options" :height="500")
    div(v-if="activeDataTypeIndex === 3")
      LineChart(:chartData="chartData" :options="options" :height="500")
</template>

<script>
/* eslint-disable */
import TrackNTrace from '@/service/apis/TrackNTrace'
import { numberFilter } from '@/filters/filters'
import ProductSelect from '@/components/ssp/ProductSelect'
import PackageSelect from '@/components/ssp/PackageSelect'
import LocationPicker from '@/components/ssp/LocationPicker'
import { PieChart, BarChart, LineChart } from '@/components/common/Charts'
import dayjs from 'dayjs'

export default {
  props: ['filter'],
  data: () => ({
    activeDataTypeIndex: 0,
    activeFilterIndex: 2,
    filterButtons: [
      { text: 'SKU', type: 'sku' },
      { text: 'Packages', type: 'packages' },
      { text: 'All', type: 'all' }
    ],
    dataTypeButtons: [
      { icon: 'fa fa-table' },
      { icon: 'fa fa-pie-chart' },
      { icon: 'fa fa-bar-chart' },
      { icon: 'fa fa-line-chart' }
    ],
    uploaded: [],
    filteredUploaded: [],
    productId: null,
    packageId: null,
    location: null,
    pieData: [],
    chartData: [],
    pieOptions: {
      maintainAspectRatio: false,
    },
    options: {
      sacleOverride: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          barThickness: 7
        }]
      }
    },
    chartColors: ['#004FE1', '#262B32', '#C6C4D2', '#1AffD5', '#FF47DA', '#E4FF1A', '#364156', '#AEb0Ae', '#7D57FB', '#35ff69', '#FF2745', '#FF5100', '#3DBDFD', '#004FE1', '#262B32', '#C6C4D2', '#1AffD5', '#FF47DA', '#E4FF1A', '#364156', '#AEb0Ae', '#7D57FB', '#35ff69', '#FF2745', '#FF5100', '#3DBDFD', '#004FE1', '#262B32', '#C6C4D2', '#1AffD5', '#FF47DA', '#E4FF1A', '#364156', '#AEb0Ae', '#7D57FB', '#35ff69', '#FF2745', '#FF5100', '#3DBDFD']
  }),
  created() {
    this.getUploadedData()
    this.getIntervalData()
  },
  methods: {
    getUploadedData() {
      const req = {}
      req.endDate = this.filter.endDate
      req.startDate = this.filter.startDate

      if (this.location) {
        req.locationId = this.location.id
      }
      if (this.packageId) {
        req.packageTypeId = this.packageId
      }
      if (this.productId) {
        req.productId = this.productId
      }

      TrackNTrace.getUploaded(req)
        .then((resp) => {
          this.uploaded = resp.data.total
        })
        .then(() => {
          this.updateFilter()
        })
    },
    getIntervalData() {
      const req = {}
      req.endDate = this.filter.endDate
      req.startDate = this.filter.startDate
      if (this.location) {
        req.locationId = this.location.id
      }
      if (this.packageId) {
        req.packageTypeId = this.packageId
      }
      if (this.productId) {
        req.productId = this.productId
      }
      TrackNTrace.getUploadedInterval(req)
        .then((resp) => {
          this.pieData = {
            labels: [],
            datasets: [{
              backgroundColor: this.chartColors,
              data: []
            }]
          }

          resp.data.series.forEach((s) => {
            s.inventory.forEach((i) => {
              this.pieData.datasets[0].data.push(i.count)
              this.pieData.labels.push(`${i.packageName} - ${i.productName}`)
            })
          })

          const set = new Set()
          resp.data.series.forEach((s) => {
            s.inventory.forEach((i) => {
              set.add(i.packageName)
            })
          })

          const packages = Array.from(set)
          const data = {}
          packages.forEach((p) => {
            data[p] = []
          })
          resp.data.series.forEach((s) => {
            for (let packageType in data) {
              const array = s.inventory.filter(f => f.packageName === packageType)
              if (array.length === 0) {
                data[packageType].push(0)
              } else {
                let sum = 0
                for (let p in array) {
                  sum += array[p].count
                }
                data[packageType].push(sum)
              }
            }
          })

          this.chartData = {
            labels: [],
            datasets: []
          }
          let colorIndex = 0
          for (let packageType in data) {
            this.chartData.datasets.push({
              data: data[packageType],
              label: packageType,
              fill: false,
              backgroundColor: this.chartColors[colorIndex += 1],
              borderColor: this.chartColors[colorIndex += 1],
              borderWidth: 0
            })
          }
          resp.data.series.forEach((s) => {
            this.chartData.labels.push(dayjs(s.startDate).format('DD/MM/YY'))
          })
        })
    },
    goToProduct(id) {
      this.$router.push(`/core/configuration/product/${id}`)
    },
    updateFilter() {
      let copy
      if (this.activeFilterIndex === 1) {
        copy = this.uploaded.filter(c => typeof c.packageName !== 'undefined')
      } else if (this.activeFilterIndex === 0) {
        copy = this.uploaded.filter(c => typeof c.productName !== 'undefined')
      } else {
        copy = this.uploaded
      }
      this.filteredUploaded = copy
    }
  },
  watch: {
    filter: {
      handler() {
        this.getUploadedData()
        this.getIntervalData()
      },
      deep: true
    },
    productId: {
      handler() {
        this.getUploadedData()
        this.getIntervalData()
      },
      deep: true
    },
    packageId: {
      handler() {
        this.getUploadedData()
        this.getIntervalData()
      },
      deep: true
    },
    location: {
      handler() {
        this.getUploadedData()
        this.getIntervalData()
      },
      deep: true
    },
    activeFilterIndex: {
      handler() {
        this.updateFilter()
      },
      deep: true
    }
  },
  components: {
    LocationPicker,
    ProductSelect,
    PackageSelect,
    PieChart,
    BarChart,
    LineChart
  },
  filters: {
    number: numberFilter
  }
}
</script>

<style lang="scss">
.p10 {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/components/Uploaded.vue